// extracted by mini-css-extract-plugin
module.exports = {"richTextWrapper":"RichText_richTextWrapper__K018a","video":"RichText_video__me9ki"};